/**
 * November 2017 - This interface moved from odsp-shared-sharing
 */

enum Mode {
    share = 1,
    copy = 2,
    atMention = 3,
    linkSettings = 4,
    manageAccess = 5,
    notify = 6,
    addPeople = 7,
}

export default Mode;
